export const FirstAccess = {
  Button: {
    Login: 'ログイン',
    AnonymousLogin: 'ログインせずに利用する',
    RegisterAccount: '新しいアカウントを作成する',
  },
};
